import React, { Component } from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import $ from "jquery";
import { Row } from "react-foundation";

import { getConservatoryTypes } from "actions";
import Loading from "components/Loading";
import InputError from "../../components/InputError";
import Select from "react-select";
import ThemeButton from "../../components/ThemeButton";
import SeparatingLine from "../../components/SeparatingLine";
import FormHeader from "../../components/FormHeader";
import FormWrapper from "../FormWrapper";

class SelectType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDropdown: false
        };
    }

    render() {
        let { conservatories } = this.props;

        if ($.isEmptyObject(conservatories)) {
            return <Loading />;
        }

        if (!this.state.showDropdown) setTimeout(() => this.setState({ showDropdown: true }), 1000);

        let kickoffClasses = "kickoff";
        let dropdownClasses = "dropdown";

        if (this.state.showDropdown) {
            kickoffClasses += " fadeout";
            dropdownClasses += " fadein";
        }

        var options = conservatories.map(r => ({ value: r.id, label: r.name }));

        return (
            <div>
                <Row isColumn>
                    <h3 className={kickoffClasses}>{"Okay, let's get started..."}</h3>

                    <h3 className={dropdownClasses}>
                        I am looking for a
                        <Select
                            onChange={val => this.props.input.onChange(val.value)}
                            options={options}
                            value={this.props.input.value}
                            clearable={false}
                            searchable={false}
                            placeholder=""
                        />
                    </h3>
                </Row>

                <InputError metas={this.props.meta} />
            </div>
        );
    }
}

class ConservatoryForm extends Component {
    componentDidMount() {
        this.props.getConservatoryTypes();
    }
    

    render() {
        return (
            <form className="ConservatoryForm" onSubmit={this.props.handleSubmit(this.props.onSubmit)}>
                <FormHeader title={""} subtitle={""} />
                <SeparatingLine />
                <FormWrapper className="VerticalAlign">
                    <Field name="ConservatoryId" component={SelectType} conservatories={this.props.conservatories} />
                </FormWrapper>
                <div className="button-panel">
                    <SeparatingLine />
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    return {
        conservatories: state.Conservatory.Types
    };
};

export default connect(mapStateToProps, { getConservatoryTypes })(ConservatoryForm);



// WEBPACK FOOTER //
// ./src/containers/ConservatoryForm/ConservatoryForm.js